<template>
    <div class="operator-bar-wrapper clr">
        <div class="opeat-l">
            <RoundButton @btnClick="addQuestionHandler" :text="addQuestion"></RoundButton>
            <RoundButton @btnClick="importHandler" :text="importText"></RoundButton>
            <RoundButton v-if="showExport" :text="exportBtn" @btnClick="exportClick" />
            <span v-if="showSync" class="sync-test-btn" @click="syncTestClick">
                <i class="el-icon-refresh"></i>{{ syncTestBtn }}
            </span>
            <span class="import-btn-wrapper">
                <StatusModel >
                    <el-tooltip class="import-btn" :content="exportTips" placement="bottom">
                        <i class="import-icon"/>
                    </el-tooltip>
                </StatusModel>
            </span>
        </div>
        <div class="opeat-r opeate-content">
            <LangSelect :value="initLang" class="lang-select" @change="langChange" :requireAll="true"></LangSelect>
            <Select :initValue="initRecommend" :options="recommendOptions" class="recommend-select" @menuClick="recommendChange" />
            <Select :init-value="initComponents" :options="componentsOptions" class="components-select" @menuClick="componentChange" />
            <Select :initValue="initStatus" :options="statusOptions" class="status-select" @menuClick="statusChange" />
            <Select :initValue="initCreator" :options="questionCreators" class="creator-select" @menuClick="creatorChange" />
            <Search
                :hasInput="true"
                :initValue="initQuestionId"
                :placeholder="placeholder"
                class="question-search"
                @searchChange="searchChange"
                @inputChange="searchChange"
            >
                <Select
                    :initValue="QuestionType"
                    :options="questionOptions"
                    class="question-select"
                    slot="right"
                    @menuClick="questionTypeChange"
                    :topOrBottom="40"
                />
            </Search>
            <Select :initValue="langType" :options="conditionOption" class="include lang-select" @menuClick="conditionChange" />
            <Select :initValue="initSmallLang" :options="smallLangOption" class="lang-select lang-select-right" @menuClick="smallLangChange" />
        </div>
    </div>
</template>

<script>
import Search from "@/views/zhiji/bComponents/inputs/Search";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import BatchImport from "./BatchImport";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";
import LangSelect from "@/components/langSelect";
import checkAuth from "@/lib/auth";
import StatusModel from "./StatusModel.vue";

import {
    statusOptions,
    creatorOptions,
    questionOptions,
    recommendOptions,
    smallLangOption,
    conditionOption,
    componentsTypeLabels
} from "../pageConfig.js";
import { debounce } from "@/views/zhiji/js/common/util.js";
import { getComponentType } from "@/views/zhiji/js/services/service.js";

export default {
    name: "OperationBar",
    props: ["data", "row", "standTotal", "initQuestionId"],
    components: {
        Search,
        RoundButton,
        Select,
        LangSelect,
        StatusModel
    },
    data() {
        return {
            QuestionType: "stand",
            pageOne: 1,
            langType: conditionOption()[0].value,
            smallLang: "",
            exportIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -66px -115px",
            exportIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -66px -115px",
            componentTypes: [],
        };
    },
    created() {
        this.getComponentTypes();
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchQuestion(searchField);
        }, 500);
    },
    computed: {
        questionCreators() {
            let options = [...this.getStorePorp("questionCreators")];

            if (!options.length) {
                options.push(...creatorOptions());
                this.$store.dispatch("zhiji/initQuesCreators");
            }

            return options;
        },
        sceneId() {
            return this.getStorePorp("querySetting").classId;
        },
        statusOptions() {
            return statusOptions();
        },
        questionOptions() {
            return questionOptions();
        },
        recommendOptions() {
            return recommendOptions();
        },
        conditionOption() {
            return conditionOption();
        },
        componentsOptions() {
            const ret = [
                {
                    label: this.$t("zhiji.knowlege.components.all"),
                    value: "all"
                }
            ];
            const labels = componentsTypeLabels();
            this.componentTypes.forEach(item => {
                ret.push({
                    label: labels[item.component],
                    value: item.component,
                    isCustomComponent: item.is_custom_component
                });
            });
            return ret;
        },
        smallLangOption() {
            return smallLangOption();
        },
        placeholder() {
            return this.$t("zhiji.common.inputHolderLabel");
        },
        addQuestion() {
            return this.$t("zhiji.knowlege.addBtnLabel");
        },
        importText() {
            return this.$t("zhiji.common.import");
        },
        querySetting() {
            return this.getStorePorp("querySetting");
        },
        initLang() {
            return this.querySetting.lang || "all";
        },
        initRecommend() {
            return this.querySetting.recommendSimilar || "all";
        },
        initStatus() {
            return this.querySetting.status || "all";
        },
        initCreator() {
            return this.querySetting.creator || "all";
        },
        initSmallLang() {
            return this.querySetting.smallLang || "all";
        },
        initComponents() {
            return this.querySetting.components || "all";
        },
        exportBtn() {
            return this.$t("zhiji.common.export");
        },
        syncTestBtn() {
            return this.$t("zhiji.knowlege.syncTestEnv");
        },
        exportTips() {
            return this.$t("zhiji.knowlege.importModal.importCheckTip");
        },
        showExport() {
            return checkAuth("knowledge.fqamanager.export");
        },
        showSync() {
            return this.$store.state.auth.is_super === 1 && !this.isTestOrPreEnv;
        },
        isTestOrPreEnv() {
            const hostname = window.location.hostname;
            return hostname.includes('test');
        },
        currentSort() {
            return this.$store.state.zhiji.questionListPage.sortTreeCurrentSelectId;
        }
    },
    watch: {
        // 监控中英文切换，重新从后台取对应语言数据
        placeholder() {
            this.$store.commit("zhiji/clearCreatorOption");
            this.getQuestionList({ page: this.pageOne });
        },
        initQuestionId: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.QuestionType = "questionId";
                    this.searchQuestion({ value: newVal });
                }
            }
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionListPage[propName];
        },
        getQuestionList(reqData) {
            this.$store.dispatch("zhiji/queryQuestionList", reqData);
            this.$store.dispatch("zhiji/queryExtQuestionTotal", reqData);
            this.$store.dispatch("zhiji/queryAnswersTotal", reqData);
            this.$emit("initCurrPage");
        },
        async getComponentTypes() {
            const result = await getComponentType();
            this.componentTypes = result || [];
        },
        importHandler() {
            this.$store.dispatch("zhiji/showModal", {
                type: BatchImport,
                data: {
                    cancel: () => {
                        this.getQuestionList({
                            page: this.pageOne
                        });
                        this.$emit("initCurrPage");
                    }
                }
            });
        },
        addQuestionHandler() {
            const classId = this.getStorePorp("querySetting").classId;

            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    questionId: "",
                    sceneId: classId,
                    closeHandler: () => {
                        this.getQuestionList({
                            page: this.pageOne
                        });
                        this.$emit("initCurrPage");
                    }
                }
            });
        },
        langChange(data) {
            this.getQuestionList({
                lang: data,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        recommendChange(data) {
            this.getQuestionList({
                recommendSimilar: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        componentChange(data) {
            let isCustomComponent;
            this.componentsOptions.forEach(item => {
                if (item.value === data.value) {
                    isCustomComponent = item.isCustomComponent;
                }
            });
            this.getQuestionList({
                components: data.value,
                page: this.pageOne,
                isCustomComponent: isCustomComponent
            });
            this.$emit("initCurrPage");
        },
        statusChange(data) {
            this.getQuestionList({
                status: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        creatorChange(data) {
            this.getQuestionList({
                creator: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        conditionChange(data) {
            this.langType = data.value;
            this.smallLang && this.queryBySmallLang();
        },
        smallLangChange(data) {
            this.smallLang = data.value;
            data.value === "all" ? (this.smallLang = "") : "";
            this.queryBySmallLang();
        },
        queryBySmallLang() {
            this.getQuestionList({
                langType: this.smallLang ? this.langType : "",
                smallLang: this.smallLang,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        questionTypeChange(data) {
            this.QuestionType = data.value;
        },
        searchChange(data) {
            this.searchHanlder(data);
        },
        searchQuestion(data) {
            let searchType = this.QuestionType;
            data.value === "" ? (searchType = "") : "";

            this.getQuestionList({
                type: searchType,
                field: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        exportClick() {
            const { querySetting } = this.$store.state.zhiji.questionListPage;
            const isFilter = this.isFilter(querySetting);
            let tipsTxt =
                isFilter === 0
                    ? this.$i18n.t("zhiji.knowlege.imExHistoryModal.exportAllTips")
                    : this.$i18n.t("zhiji.knowlege.imExHistoryModal.exportFilterTips");
            let sceneStr = "";
            if (this.currentSort.id) {
                sceneStr = this.currentSort.label;
                tipsTxt = `${this.$i18n.t("zhiji.knowlege.imExHistoryModal.exportBySceneTipsOne")} ${sceneStr} ${this.$i18n.t(
                    "zhiji.knowlege.imExHistoryModal.exportBySceneTipsTwo"
                )}`;
            }
            this.$confirm(tipsTxt, this.$t("zhiji.common.tips"), {
                confirmButtonText: this.$t("zhiji.common.confirm"),
                cancelButtonText: this.$t("zhiji.common.cancel"),
                type: "warning"
            }).then(() => {
                this.zhiji
                    .requestByServiceName("bySceneExportFaq", {
                        ...querySetting,
                        type: this.QuestionType || "",
                        sceneId: this.currentSort.id || "",
                        isFilter
                    })
                    .then(res => {
                        // eslint-disable-next-line no-unused-expressions
                        res &&
                            this.$message({
                                message: this.$i18n.t("zhiji.knowlege.imExHistoryModal.successTip"),
                                type: "success"
                            });
                    });
            });
        },
        syncTestClick() {
            let tipsTxt = this.$i18n.t("zhiji.knowlege.syncTestAllTips")
            let sceneStr = "";
            if (this.currentSort.id) {
                sceneStr = this.currentSort.label;
                tipsTxt = `${this.$i18n.t("zhiji.knowlege.syncTestConfirmBySceneOne")} ${sceneStr} ${this.$i18n.t("zhiji.knowlege.syncTestConfirmBySceneTwo")}`;
            }
            this.$confirm(tipsTxt, this.$t("zhiji.common.tips"), {
                confirmButtonText: this.$t("zhiji.common.confirm"),
                cancelButtonText: this.$t("zhiji.common.cancel"),
                type: "warning"
            }).then(() => {
                this.zhiji
                    .requestByServiceName("syncFaqToTest", {
                        setId: this.currentSort.id || 0,
                    })
                    .then(res => {
                        // eslint-disable-next-line no-unused-expressions
                        res &&
                            this.$message({
                                message: this.$i18n.t("zhiji.knowlege.syncTestSuccessTip"),
                                type: "success"
                            });
                    });
            });
        },
        isFilter(reqData) {
            // 是否有筛选字段
            let isFilter = 0;
            const filterField = [
                "components",
                "isCustomComponent",
                "recommendSimilar",
                "lang",
                "status",
                "creator",
                "langType",
                "smallLang",
                "field",
            ];
            filterField.forEach(item => {
                if (reqData[item] && reqData[item] !== "all" && reqData[item] !== "") {
                    isFilter = 1;
                }
            });
            return isFilter;
        }
    }
};
</script>

<style lang="less" scoped>
.operator-bar-wrapper {
    .opeat-l,
    .select-opt,
    .opeat-r {
        display: inline-block;
    }
    .import-btn {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
    }
    .import-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-bottom: 5px;
        background: url(//ossweb-img.qq.com/images/xiaoyue/images/manager/website/class-spr2.png) -101px -142px no-repeat;
        vertical-align: middle;
        &:hover {
            background-position: -127px -142px;
        }
    }
    .opeat-l,
    .opeat-r {
        font-size: 0;
        float: left;
        margin-bottom: 8px;
    }

    .lang-select,
    .status-select,
    .creator-select,
    .question-search,
    .lang-select,
    .recommend-select,
    .components-select {
        width: 130px;
        margin-right: 8px;
        margin-bottom: 8px;
        display: inline-block;
        vertical-align: middle;
    }

    .include {
        margin-right: 0;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
    }

    .lang-select-right {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        width: 185px;
    }

    .question-search {
        display: inline-flex;
    }

    .question-search {
        font-size: 12px;
        width: 318px;
    }

    .question-select {
        border: 0;
        border-right: 1px solid #e3e3e3;
        border-radius: 0;
        /deep/.select-input-popup {
            width: 136px;
        }
    }
    .sync-test-btn {
        display: inline-block;
        min-width: 120px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #fff;
        background: #2ec2ff;
        box-shadow: 0 0 6px 2px rgba(46, 98, 151, 0.2);
        border-radius: 30px;
        font-size: 14px;
        margin-right: 16px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
            background: rgba(46, 194, 255, 0.8);
        }
        .el-icon-refresh {
            margin-right: 5px;
            font-size: 14px;
        }
    }
    .import-btn-wrapper {
        display: inline-block;
        vertical-align: middle;
    }
    
}
.clr {
    &:after {
        content: " ";
        clear: both;
        height: 0;
        visibility: hidden;
        display: block;
    }
}
</style>
